import { render, staticRenderFns } from "./TokenRequestPage.vue?vue&type=template&id=228a05b2&scoped=true&"
import script from "./TokenRequestPage.vue?vue&type=script&lang=js&"
export * from "./TokenRequestPage.vue?vue&type=script&lang=js&"
import style0 from "./TokenRequestPage.vue?vue&type=style&index=0&id=228a05b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a05b2",
  null
  
)

export default component.exports